module.exports = __webpack_public_path__ + "static/img/appxiazai_moxing.e443f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/appxiazai_moxing.png
// module id = XJjw
// module chunks = 1